// First import in the entry point, so the handlers are installed before anything else can throw.
import './sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';

import { App } from './App';

/**
 * Bootstrap only.
 *
 * The tree itself lives in `App.tsx`: this file has no exports, and a component declared in one
 * cannot be hot-reloaded — `react(only-export-components)` fails the build on it.
 */
const root = document.getElementById('app');
if (!root) throw new Error('Root element #app not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
